import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import itemId from 'owa-service/lib/factory/itemId';
import applyConversationActionOperation from 'owa-service/lib/operation/applyConversationActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
function createConversationAction(conversationId, inferenceClassification) {
    return conversationAction({
        Action: 'SetInferenceClassificationState',
        ConversationId: itemId({ Id: conversationId }),
        InferenceClassification: inferenceClassification,
    });
}
/**
 * Configure the request body
 * @param conversationIds the conversation ids
 * @param inferenceClassification the inferenceClassification value to update
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationIds, inferenceClassification) {
    var conversationActions = conversationIds.map(function (conversationId) {
        return createConversationAction(conversationId, inferenceClassification);
    });
    return applyConversationActionRequest({
        ConversationActions: conversationActions,
    });
}
/**
 * Set InferenceClassification service
 * @param conversationIds the conversation ids
 * @param inferenceClassification the inferenceClassification value to update
 * @return the ApplyConversationActionResponseMessage
 */
export function setConversationInferenceClassificationService(conversationIds, inferenceClassification) {
    var requestBody = configureRequestBody(conversationIds, inferenceClassification);
    return applyConversationActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=setConversationInferenceClassificationService.js.map